<template>
  <div class="stop-reason">
    <div class="main-title">
      <p @click="toList">{{ $t('lang.Change charge station management') }}</p>
      <p @click="toDetail">>{{ $t('lang.Details') }}</p>
      <p>>{{ $t('lang.Operation and maintenance records') }}</p>
    </div>
    <div class="main-body">
      <div class="list">
        <div class="name-label">{{ $t('lang.time') }}：</div>
        <el-date-picker
          v-model="startTime"
          class="date-global"
          size="mini"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          :placeholder="$t('lang.start time')">
        </el-date-picker>
        <span>-</span>
        <el-date-picker
          v-model="endTime"
          size="mini"
          class="date-global"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          :placeholder="$t('lang.end time')">
        </el-date-picker>
        <span class="ml10">{{ $t('lang.Port number') }}：</span>
        <el-select
          class="fixed-width-100"
          size="mini"
          v-model="seqNo">
          <el-option
            v-for="(item,key) in seqNoList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <span class="ml10">{{ $t('lang.content') }}：</span>
        <el-select
          class="fixed-width-100"
          size="mini"
          v-model="operateType">
          <el-option
            v-for="(item,key) in operateTypeList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <div class="blue-btn ml10" @click="onQueryBtnClick">{{ $t('lang.Inquire') }}</div>
      </div>
      <!-- <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column prop="name" label="发送时间"></el-table-column>
        <el-table-column prop="path" label="端口编号"></el-table-column>
        <el-table-column prop="icon" label="类型"></el-table-column>
        <el-table-column prop="sort" label="操作人"></el-table-column>
        <el-table-column prop="sort" label="内容"></el-table-column>
        <el-table-column prop="sort" label="状态">
          <template slot-scope="{row}">
          </template>
        </el-table-column>
      </el-table>
      <div class="dfcc">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          prev-text="上一页"
          next-text="下一页"
          layout=" prev, next"
          :total="total">
        </el-pagination>
      </div> -->
      <table class="table-custom">
        <thead>
        <tr>
          <th>{{ $t('lang.Send time') }}</th>
          <th>{{ $t('lang.Port number') }}</th>
          <th>{{ $t('lang.type') }}</th>
          <th>{{ $t('lang.operator') }}</th>
          <th>{{ $t('lang.content') }}</th>
          <th>{{ $t('lang.Operation reason') }}</th>
          <th>{{ $t('lang.status') }}</th>
        </tr>
        </thead>
        <tbody v-if="dataList.length>0">
        <tr v-for="(item,index) in dataList" :key="index">
          <td>{{ $changeTime.showTime(item.createTime) }}</td>
          <td>{{ item.chargePortSeqNo ? item.chargePortSeqNo + $t('lang.No') : "--" }}</td>
          <td>{{ $t('lang.' + $changeObj(source_Type_Code)[item.sourceTypeCode]) }}</td>
          <td>
            {{ item.operationUserName ? item.operationUserName + '-' + item.operationUserPhone : item.operationUserPhone }}
          </td>
          <td>{{ $t('lang.' + $changeObj(operate_type_code)[item.operateTypeCode]) }}</td>
          <td>{{ item.operationReason }}</td>
          <td>{{ $t('lang.' + $changeObj(status_Code)[item.statusCode]) }}</td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan='7'>{{ $t('lang.no data') }}</td>
        </tr>
        </tbody>
      </table>
      <div class="page-box">
        <div class="page-count">{{ $t('lang.The') }} {{ pageIndex }}
          {{ $t('lang.page') }}，{{ $t('lang.The current page') }} {{ dataList.length }}
          {{ $t('lang.item') }}，{{ total }} {{ $t('lang.item') }}
        </div>
        <div class="page-count">{{ $t('lang.Jump to') }}
          <el-input v-model="page" class="page-choose fixed-width-35" size="mini"></el-input>
          {{ $t('lang.page') }}
        </div>
        <div class="page-count text-btn" @click="onPageChooseBtnClick">{{ $t('lang.Jump to') }}</div>
        <div class="pre-btn" :class="preBtnDisabled?'disabled':''" @click="onPreBtnClick">
          {{ $t('lang.Previous page') }}
        </div>
        <div class="next-btn" :class="nextBtnDisabled?'disabled':''" @click="onNextBtnClick">
          {{ $t('lang.Next page') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Utils from "../../utils/utils";
import {status_Code, source_Type_Code, operate_type_code} from '@/utils/constant'

export default {
  name: 'stopReason',
  data() {
    return {
      status_Code,
      operate_type_code,
      source_Type_Code,
      tableData: [],
      seqNo: '',
      seqNoList: [
        {
          name: this.$t('lang.all'),
          id: ''
        },
        {
          name: '1',
          id: 1,
        },
        {
          name: '2',
          id: 2,
        },
        {
          name: '3',
          id: 3,
        },
        {
          name: '4',
          id: 4,
        },
        {
          name: '5',
          id: 5,
        },
        {
          name: '6',
          id: 6,
        },
        {
          name: '7',
          id: 7,
        },
        {
          name: '8',
          id: 8,
        },
        {
          name: '9',
          id: 9,
        },
        {
          name: '10',
          id: 10,
        },
        {
          name: '11',
          id: 11,
        },
        {
          name: '12',
          id: 12,
        }
      ],
      operateType: '',
      operateTypeList: [
        {
          name: this.$t('lang.all'),
          id: '',
        },
        {
          name: this.$t('lang.electricity'),
          id: 1,
        },
        {
          name: this.$t('lang.Power cut'),
          id: 2,
        },
        {
          name: this.$t('lang.Open the door'),
          id: 3,
        },
        {
          name: this.$t('lang.Enable'),
          id: 7,
        },
        {
          name: this.$t('lang.unenable'),
          id: 8,
        }
      ],
      pageSize: 10,
      beginIndex: 0,
      pageIndex: 1,
      page: 1,
      total: '',
      totalPage: 0,
      preBtnDisabled: true,
      nextBtnDisabled: false,
      startTime: '',
      endTime: '',
      chargePortSeqNo: '',
      primaryDeviceNo: '',
      dataList: [],
      searchCondition: '',
      deviceName: '',
      begin: 0
    }
  },
  mounted() {
    this.startTime = Utils.getCurrentDate() + " 00:00";
    this.endTime = Utils.getCurrentDate() + " 23:59";
    if (this.$route.query.primaryDeviceNo) {
      this.primaryDeviceNo = this.$route.query.primaryDeviceNo;
    }
    this.queryStopReason();
    if (this.$route.query.searchCondition) {
      this.searchCondition = this.$route.query.searchCondition;
    }
    if (this.$route.query.deviceName) {
      this.deviceName = this.$route.query.deviceName;
    }
    if (this.$route.query.beginIndex) {
      this.begin = this.$route.query.beginIndex;
    }
  },
  methods: {
    // 分页
    handleCurrentChange(i) {

    },


    queryStopReason() {
      let self = this;
      let params = {
        primaryDeviceNo: this.primaryDeviceNo,
        chargePortSeqNo: this.seqNo,
        beginIndex: this.beginIndex,
        pageSize: this.pageSize + 1,
        beginTime: this.$changeTime.sendTime(this.startTime, 'YYYY-MM-DD HH:mm'),
        endTime: this.$changeTime.sendTime(this.endTime, 'YYYY-MM-DD HH:mm'),
        operateType: this.operateType
      };
      this.$http.post('/managementPlatform/electricity/queryOpercationRecord', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || self.$t('lang.Query failed'),
            center: true
          });
          return;
        }
        self.dataList = res.ldata;
        self.resetPreAndNextBtn(self.dataList.length);
        self.dataList.length > self.pageSize && self.dataList.pop();
        self.page = Math.floor(self.beginIndex / self.pageSize) + 1;
        self.pageIndex = self.page;
        self.total = res.mdata.total;
        self.totalPage = Math.floor((parseInt(res.mdata.total) - 1) / self.pageSize) + 1;
      }).catch(function (response) {
        console.log(response);
      });
    },
    onPreBtnClick() {
      if (this.preBtnDisabled) {
        return;
      }
      this.beginIndex <= this.pageSize && (this.beginIndex = 0);
      this.beginIndex > this.pageSize && (this.beginIndex -= this.pageSize);
      this.queryStopReason();
    },
    onNextBtnClick() {
      if (this.nextBtnDisabled) {
        return;
      }
      this.beginIndex += this.pageSize;
      this.queryStopReason();
    },
    resetPreAndNextBtn(length) {
      this.beginIndex == 0 && (this.preBtnDisabled = true);
      this.beginIndex > 0 && (this.preBtnDisabled = false);
      length > this.pageSize && (this.nextBtnDisabled = false);
      length <= this.pageSize && (this.nextBtnDisabled = true);
    },
    onQueryBtnClick: function () {
      this.dataList = [];
      this.beginIndex = 0;
      this.queryStopReason();
    },
    onPageChooseBtnClick() {
      let index = 0;
      if (this.page <= this.totalPage && this.page > 0) {
        index = this.page;
      } else {
        index = 1;
        this.page = 1;
      }
      this.beginIndex = (index - 1) * this.pageSize;
      this.queryStopReason();
    },
    toList() {
      this.$router.push("/managePage/batterySwapMgmt?searchCondition=" + this.searchCondition + "&deviceName=" + this.deviceName + "&beginIndex=" + this.begin);
    },
    toDetail() {
      this.$router.push("/managePage/batterySwapMgmt?primaryDeviceNo=" + this.primaryDeviceNo + "&searchCondition=" + this.searchCondition + "&deviceName=" + this.deviceName + "&beginIndex=" + this.begin);
    }
  },
}
</script>
<style lang="scss" scoped>
.list {
  line-height: 30px;
  margin: 20px 0px 10px;
  overflow: hidden;

  .name-label {
    float: left;
  }

  .value-label {
    float: left;
    width: 17%;
    height: 30px;
  }

  .date-global {
    width: 185px;
  }

  .list-input {
    width: 180px;
  }

  .fixed-width-100 {
    width: 100px;
  }
}

.table-custom {
  .text-btn {
    width: 50px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #BEE6B3;
    cursor: pointer;
  }

  .fixed-width-75 {
    width: 75px;
  }

  .fixed-width-120 {
    width: 120px;
  }

  .fixed-width-60 {
    width: 60px;
  }
}

.ml-40 {
  margin-left: 40px;
}

.pre-btn {
  width: 84px;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/stopReason.vue